import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { storyblokInit, apiPlugin } from "@storyblok/react";

import NotificationStripNav from "./components/core/NotificationStripNav/NotificationStripNav";
import MainPage from "./components/core/MainPage/MainPage";
import RedirectPage from "./components/core/MainPage/RedirectPage";
import Page from "./components/core/Page/Page";
import Button from "./components/core/Button/Button";
import InputField from "./components/core/InputField/InputField";
import Textarea from "./components/core/Textarea/Textarea";
import TablePanel from "./components/core/TablePanel/TablePanel";
import IconButton from "./components/core/IconButton/IconButton";
import Hyperlink from "./components/core/Hyperlink/Hyperlink";
import YoutubePopup from "./components/core/YoutubePopup/YoutubePopup";

import GlobalReference from "./components/core/GlobalReference/GlobalReference";
import NotificationStrip from "./components/core/NotificationStrip/NotificationStrip";
import Nav from "./components/core/Nav/Nav";
import NavButton from "./components/core/NavButton/NavButton";
import NavSearch from "./components/core/NavSearch/NavSearch";
import NavDropdownItem from "./components/core/NavDropdownItem/NavDropdownItem";
import Footer from "./components/core/Footer/Footer";

import FontTest from "./components/product/FontTest/FontTest";
import InfoTextBanner from "./components/product/InfoTextBanner/InfoTextBanner";
import MegaMediaBanner from "./components/product/MegaMediaBanner/MegaMediaBanner";
import MegaMediaBannerV2 from "./components/product/MegaMediaBannerV2/MegaMediaBannerV2";
import ShowcasePanel from "./components/product/ShowcasePanel/ShowcasePanel";
import ListPanel from "./components/product/ListPanel/ListPanel";
import FilterListPanel from "./components/product/FilterListPanel/FilterListPanel";
import PeopleItem from "./components/product/ListPanel/PeopleItem/PeopleItem";
import ListPanelItem from "./components/product/ListPanel/ListPanelItem/ListPanelItem";
import BenefitItem from "./components/product/ListPanel/BenefitItem/BenefitItem";
import FeatureGridPanel from "./components/product/FeatureGridPanel/FeatureGridPanel";
import FeatureGridPanelItem from "./components/product/FeatureGridPanel/FeatureGridPanelItem/FeatureGridPanelItem";
import FeatureTablePanelMobile from "./components/product/FeatureTablePanel/FeatureTablePanelMobile";
import FeatureTablePanelDesktop from "./components/product/FeatureTablePanel/FeatureTablePanelDesktop";
import FeatureTablePanel from "./components/product/FeatureTablePanel/FeatureTablePanel";
import SliderPanel from "./components/product/SliderPanel/SliderPanel";
import SliderPanelItem from "./components/product/SliderPanel/SliderPanelItem/SliderPanelItem";
import SolutionsSliderPanelItem from "./components/product/SliderPanel/SolutionsSliderPanelItem/SolutionsSliderPanelItem";
import PricingPanel from "./components/product/PricingPanel/PricingPanel";
import BasicPanel from "./components/product/BasicPanel/BasicPanel";
import BasicPanelContent from "./components/product/BasicPanelContent/BasicPanelContent";
import ExternalForms from "./components/product/ExternalForms/ExternalForms";
import InfoPanel from "./components/product/InfoPanel/InfoPanel";
import PressTimeline from "./components/Article/PressTimeline/PressTimeline";
import PressTimelineItem from "./components/Article/PressTimeline/PressTimelineItem/PressTimelineItem";
import Article from "./components/Article/Article/Article";
import ArticleContent from "./components/Article/ArticleContent/ArticleContent";
import Faq from "./components/Faq/Faq/Faq";
import DownloadsContent from "./components/downloads/DownloadsContent/DownloadsContent";
import ProductDownloads from "./components/downloads/ProductDownloads/ProductDownloads";
import Download from "./components/downloads/Download/Download";
import SearchContent from "./components/Search/SearchContent/SearchContent";
import TagCategory from "./components/TagCategory/TagCategory/TagCategory";
import SupportLanding from "./components/support/SupportLanding/SupportLanding";
import Support from "./components/support/Support/Support";
import LevelJourney from "./components/support/LevelJourney/LevelJourney";
import SupportItem from "./components/support/SupportItem/SupportItem";
import SupportProductItem from "./components/support/SupportProductItem/SupportProductItem";
import ContactUs from "./components/support/ContactUs/ContactUs";
import ContactUsSuccess from "./components/support/ContactUs/ContactUsSuccess";
import ContactUsLevelJourney from "./components/support/ContactUsLevelJourney/ContactUsLevelJourney";
import NotFound from "./components/error/NotFound/NotFound";
import ServerError from "./components/error/ServerError/ServerError";

storyblokInit({
  accessToken: process.env.REACT_APP_STORYBLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  components: {
    MainPage,
    RedirectPage,
    NotificationStripNav,
    Page,
    Button,
    IconButton,
    GlobalReference,
    Hyperlink,
    YoutubePopup,
    InputField,
    Textarea,

    NotificationStrip,
    Nav,
    NavButton,
    NavSearch,
    NavDropdownItem,
    Footer,
    TablePanel,

    InfoTextBanner,
    MegaMediaBanner,
    MegaMediaBannerV2,
    ShowcasePanel,
    ListPanel,
    FilterListPanel,
    PeopleItem,
    ListPanelItem,
    BenefitItem,
    FeatureTablePanel,
    FeatureTablePanelDesktop,
    FeatureTablePanelMobile,
    SliderPanel,
    SliderPanelItem,
    SolutionsSliderPanelItem,
    PricingPanel,
    BasicPanel,
    BasicPanelContent,
    ExternalForms,
    InfoPanel,
    FeatureGridPanel,
    FeatureGridPanelItem,

    Article,
    ArticleContent,
    Faq,
    DownloadsContent,
    ProductDownloads,
    Download,
    PressTimeline,
    PressTimelineItem,

    SearchContent,

    TagCategory,

    SupportLanding,
    LevelJourney,
    Support,
    SupportItem,
    SupportProductItem,
    ContactUs,
    ContactUsSuccess,
    ContactUsLevelJourney,

    NotFound,
    ServerError,
    FontTest,
  },
  apiOptions: {
    region: "",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
